const f = ["#92bfc7", "#9d64a6", "#b72619", "#de9d36", "#ffff54"], _ = [
  "#92bfc7",
  "#9d64a6",
  "#a34f7e",
  "#b72619",
  "#de9d36",
  "#ffff54"
], e = [
  "#92bfc7",
  "#9d64a6",
  "#a34f7e",
  "#b72619",
  "#de9d36",
  "#eece45",
  "#ffff54"
], E = [
  "#92bfc7",
  "#93a0bb",
  "#9d64a6",
  "#a34f7e",
  "#b72619",
  "#de9d36",
  "#eece45",
  "#ffff54"
], c = [
  "#92bfc7",
  "#93a0bb",
  "#9d64a6",
  "#a34f7e",
  "#b72619",
  "#c2411f",
  "#de9d36",
  "#eece45",
  "#ffff54"
], b = [
  "#92bfc7",
  "#93a0bb",
  "#9d64a6",
  "#a34f7e",
  "#aa3c56",
  "#b72619",
  "#c2411f",
  "#de9d36",
  "#eece45",
  "#ffff54"
];
export {
  b as HEAT_MAP_BLUE_RED_YELLOW_10,
  f as HEAT_MAP_BLUE_RED_YELLOW_5,
  _ as HEAT_MAP_BLUE_RED_YELLOW_6,
  e as HEAT_MAP_BLUE_RED_YELLOW_7,
  E as HEAT_MAP_BLUE_RED_YELLOW_8,
  c as HEAT_MAP_BLUE_RED_YELLOW_9
};
//# sourceMappingURL=index.es5575.js.map
